// extracted by mini-css-extract-plugin
export default {"PhoneNumberButton":"PhoneNumberButton_PhoneNumberButton","PhoneNumber":"PhoneNumberButton_PhoneNumber"};